import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link, useNavigate } from 'react-router-dom';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        navigate('/');
      }, 2000); // Redirect to login page after 2 seconds
      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [message, navigate]);

  const handleSubmit = async () => {
    try {
      if (password !== confirmPassword) {
        setError('Passwords do not match');
        return;
      }
      const response = await axios.post(`https://whats-app.360websitedemo.com/api/reset-password/${token}`, {
        password,
        confirmPassword,
      });
      setMessage(response.data.message);
      setPassword('');
      setConfirmPassword('');
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
      setMessage('');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="w-full max-w-4xl flex bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="w-1/2 bg-green-700 text-white p-8">
          <h1 className="text-2xl font-bold mb-4">WhatsApp Sender</h1>
          <p className="mb-6">Set a new password to secure your account</p>
          <div className="space-y-4">
            <p className="text-green-100">Strong password protection</p>
            <p className="text-green-100">Quick and secure reset</p>
          </div>
        </div>
        <div className="w-1/2 p-8">
          <h2 className="text-xl font-semibold mb-6">Reset Password</h2>
          <p className="text-gray-600 mb-6">Enter your new password below</p>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          {message && <p className="text-green-600 mb-4">{message}</p>}
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">New Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="••••••••"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-1">Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="••••••••"
                required
              />
            </div>
            <button
              type="button"
              onClick={handleSubmit}
              className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
            >
              Reset Password
            </button>
          </div>
          <p className="mt-4 text-center text-gray-600 text-sm">
            <Link to="/" className="text-blue-600 hover:underline">Back to Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;